import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon-Close-hover",
  "use": "icon-Icon-Close-hover-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-Icon-Close-hover\"><rect width=\"24\" height=\"24\" rx=\"4\" fill=\"#ECF0FB\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.942 8.457a1 1 0 0 0-1.414-1.414l-3.535 3.535-3.536-3.535a1 1 0 0 0-1.414 1.414l3.535 3.536-3.535 3.535a1 1 0 1 0 1.414 1.414l3.536-3.535 3.535 3.535a1 1 0 1 0 1.414-1.414l-3.535-3.535 3.535-3.536Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol